@if (authMatchDataEntries().length) {
	<tec-tile
		[title]="'PROCESSES.DETAIL.AUTH_MATCH_DATA_TITLE' | translate"
		icon="icon-file"
	>
		<div class="grid grid-i2">
			@for (entry of authMatchDataEntries(); track entry.key) {
				<tec-info-group [label]="entry.label">
					@if (entry.isDate) {
						@if (entry.key === 'expiration_date') {
							<span>{{ (entry.value | expirationDate: 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
						} @else {
							<span>{{ (entry.value | safeDate: 'dd/MM/yyyy') || ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
						}
					} @else {
						<span>{{ entry.value }}</span>
					}
				</tec-info-group>
			}
		</div>
	</tec-tile>
}
@if (
	hasProcessRequirementsChecks ||
	hasProcessCompareChecks ||
	hasProcessAntifraudChecks
) {
	@if (hasProcessRequirementsChecks) {
		<tec-tile [title]="'PROCESSES.DETAIL.REQUIREMENTS' | translate">
			@if (showDeveloperCurl && processUuid) {
				<ng-container actions>
					<app-developer-curl-button
            			ngProjectAs="tec-button-icon"
						[path]="'/process/' + processUuid + '/checks/requirements'"
						titleKey="PROCESSES.CURL_MODAL.TITLE_CHECKS_REQUIREMENTS"
					/>
				</ng-container>
			}
			@if (detail?.data?.OCR?.antifraud?.DOCUMENT_TYPE ||
				detail?.data?.OCR?.antifraud?.COUNTRY ||
				detail?.data?.OCR?.antifraud?.EXPIRATED ||
				detail?.data?.OCR?.antifraud?.LEGAL_AGE ||
				showFormChecksInProcess ||
				detail?.data?.DOCUMENTS ||
				hasEvaluationRequirementsChecks ||
				hasAttorneyPowersRequirementsChecks
			) {
				@if (detail?.data?.OCR) {
					<div style="gap: 8px; display: flex; flex-flow: column;">
						<span style="display: inline-flex; gap: 6px; align-items: center;">
							{{ ('PROCESSES.DETAIL.OCR' | translate).toUpperCase() }}
							@if (detail.data.OCR.state) {
								<tec-tag
									[label]="'MASTER.STATUS.' + detail.data.OCR.state | translate"
									[status]="masterService.getTagStatus(detail.data.OCR.state)"
								/>
							}
						</span>
						<app-checks
							[detail]="detail"
							[checks]="[CHECK.OCR_DOCUMENT_TYPE, CHECK.COUNTRY, CHECK.EXPIRATED, CHECK.LEGAL_AGE]"
						/>
					</div>
				}
				@if (detail?.data?.DOCUMENTS) {
					<div style="gap: 8px; display: flex; flex-flow: column;">
						{{ ('PROCESSES.DETAIL.DOCUMENTS' | translate).toUpperCase() }}
						<app-checks
							[detail]="detail"
							[checks]="[CHECK.DOCUMENT_TYPE, CHECK.DOCUMENT_STATE]"
						/>
					</div>
				}
				@if (hasEvaluationRequirementsChecks) {
					<div style="gap: 8px; display: flex; flex-flow: column;">
						{{ ('PROCESSES.DETAIL.FINANCIAL_EVALUATION' | translate).toUpperCase() }}
						<app-checks
							[detail]="detail"
							[checks]="[CHECK.FINANCIAL_STATE]"
						/>
					</div>
				}
				@if (hasAttorneyPowersRequirementsChecks) {
					<div style="gap: 8px; display: flex; flex-flow: column;">
						{{ ('WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS' | translate).toUpperCase() }}
						<app-checks
							[detail]="detail"
							[checks]="[CHECK.ATTORNEY_POWERS_STATE]"
						/>
					</div>
				}
				@if (showFormChecksInProcess && formChecksProcessDetail; as formChecksDetail) {
					<div style="gap: 8px; display: flex; flex-flow: column;">
						{{ ('PROCESSES.DETAIL.FORM' | translate).toUpperCase() }}
						<app-checks
							[detail]="formChecksDetail"
							[checks]="formProcessRequirementChecks"
						/>
					</div>
				}
			} @else {
				<tec-empty-state
					[title]="'PROCESSES.DETAIL.CHECKS_EMPTY' | translate"
					[size]="'default'"
					[type]="'empty'"
				></tec-empty-state>
			}
		</tec-tile>
	}

	@if (hasProcessCompareChecks) {
		<tec-tile class="checks" [title]="'PROCESSES.DETAIL.COMPARE_INFO' | translate">
			@if (showDeveloperCurl && processUuid) {
				<ng-container actions>
					<app-developer-curl-button
            			ngProjectAs="tec-button-icon"
						[path]="'/process/' + processUuid + '/checks/contrast'"
						titleKey="PROCESSES.CURL_MODAL.TITLE_CHECKS_CONTRAST"
					/>
				</ng-container>
			}
			@if (
				processHelper.hasDisplayableOcrCompareAntifraud(detail?.data?.OCR) ||
				isOcrKoMatchDataError(detail?.data?.OCR)
			) {
				<div style="gap: 8px; display: flex; flex-flow: column;">
					<span style="display: inline-flex; gap: 6px; align-items: center;">
						{{ ('PROCESSES.DETAIL.OCR' | translate).toUpperCase() }}
						@if (detail?.data?.OCR?.state) {
							<tec-tag
								[label]="'MASTER.STATUS.' + detail.data.OCR.state | translate"
								[status]="masterService.getTagStatus(detail.data.OCR.state)"
							/>
						}
					</span>
					<app-checks
						[detail]="detail"
						[checks]="ocrProcessCompareChecks"
					/>
				</div>
			}
			@if (showFormChecksInProcess && formChecksProcessDetail && hasFormProcessCompareChecks) {
				<div style="gap: 8px; display: flex; flex-flow: column;">
					{{ ('PROCESSES.DETAIL.FORM' | translate).toUpperCase() }}
					<app-checks
						[detail]="formChecksProcessDetail"
						[checks]="formProcessCompareChecks"
					/>
				</div>
			}
			@if (
				showFormMatchCompareInProcess &&
				!showFormChecksInProcess &&
				formChecksProcessDetail
			) {
				<div style="gap: 8px; display: flex; flex-flow: column;">
					{{ ('PROCESSES.DETAIL.FORM' | translate).toUpperCase() }}
					<app-checks
						[detail]="formChecksProcessDetail"
						[checks]="formMatchOnlyCompareChecks"
					/>
				</div>
			}
			@if (
				processHelper.shouldDisplayAntifraudCheck(
					detail?.data?.POL?.state,
					detail?.data?.POL?.antifraud?.FACIAL_RECOGNITION
				)
			) {
				<div style="gap: 8px; display: flex; flex-flow: column;">
					<span style="display: inline-flex; gap: 6px; align-items: center;">
						{{ ('PROCESSES.DETAIL.POL' | translate).toUpperCase() }}
						@if (detail?.data?.POL?.state) {
							<tec-tag
								[label]="'MASTER.STATUS.' + detail.data.POL.state | translate"
								[status]="masterService.getTagStatus(detail.data.POL.state)"
							/>
						}
					</span>
					<app-checks
						[detail]="detail"
						[checks]="[CHECK.FACIAL_RECOGNITION]"
					/>
				</div>
			}
			@if (hasDocumentsExternalCompare()) {
				<div style="gap: 8px; display: flex; flex-flow: column;">
					{{ ('PROCESSES.DETAIL.DOCUMENTS' | translate).toUpperCase() }}
					<app-checks
						[detail]="detail"
						[checks]="[CHECK.DOCUMENTS_EXTERNAL_COMPARE]"
					/>
				</div>
			}
		</tec-tile>
	}

	@if (hasProcessAntifraudChecks) {
		<tec-tile class="checks" [title]="'PROCESSES.DETAIL.ANTIFRAUD' | translate">
			@if (showDeveloperCurl && processUuid) {
				<ng-container actions>
					<app-developer-curl-button
            			ngProjectAs="tec-button-icon"
						[path]="'/process/' + processUuid + '/checks/antifraud'"
						titleKey="PROCESSES.CURL_MODAL.TITLE_CHECKS_ANTIFRAUD"
					/>
				</ng-container>
			}
			@if (detail?.data?.OCR) {
				<div style="gap: 8px; display: flex; flex-flow: column;">
					<span style="display: inline-flex; gap: 6px; align-items: center;">
						{{ ('PROCESSES.DETAIL.OCR' | translate).toUpperCase() }}
						@if (detail.data.OCR.state) {
							<tec-tag
								[label]="'MASTER.STATUS.' + detail.data.OCR.state | translate"
								[status]="masterService.getTagStatus(detail.data.OCR.state)"
							/>
						}
					</span>
					<app-checks
						[detail]="detail"
						[checks]="[
							(shouldShowOcrKoInAntifraud ? CHECK.KO_OCR : undefined),
							CHECK.PROHIBITED_CAMERAS_OCR,
							CHECK.PHOTOCOPY,
							CHECK.SCREENPHOTO,
							CHECK.MANIPULATED_PHOTO,
							CHECK.FRAUD_ID_BLOCK
						]"
					/>
				</div>
			}
			@if (detail?.data?.POL) {
				<div style="gap: 8px; display: flex; flex-flow: column;">
					<span style="display: inline-flex; gap: 6px; align-items: center;">
						{{ ('PROCESSES.DETAIL.POL' | translate).toUpperCase() }}
						@if (detail.data.POL.state) {
							<tec-tag
								[label]="'MASTER.STATUS.' + detail.data.POL.state | translate"
								[status]="masterService.getTagStatus(detail.data.POL.state)"
							/>
						}
					</span>
					<app-checks
						[detail]="detail"
						[checks]="[
							(shouldShowPolKoInAntifraud ? CHECK.KO_POL : undefined),
							CHECK.PROHIBITED_CAMERAS_POL,
							CHECK.FRAUD_FACE,
							CHECK.FRAUD_FACE_BLOCK,
							CHECK.ANTISPOOF,
							(rolePermissions.isSuperadmin() ? CHECK.ANTISPOOF_LAB : undefined),
							CHECK.RANGE_AGE
						]"
					/>
				</div>
			}
		</tec-tile>
	}
} @else if (showChecksTabEmptyState) {
	<tec-empty-state
		[title]="'PROCESSES.DETAIL.CHECKS_EMPTY' | translate"
		[size]="'default'"
		[type]="'empty'"
	></tec-empty-state>
}
